import { Box, Text } from "@wix/design-system";
import React, { useContext } from "react";
import SiteContext from "../../contexts/site-context";
interface SyncedDateParams {
  source?: string;
  date?: string;
}
const SyncedDate = ({ source }: SyncedDateParams) => {
  /*
  |--------------------------------------------------------------------------
  | Get Site Details
  |--------------------------------------------------------------------------
  |
  */
  const { faireProductSync, faireOrderSync, wixProductSync } = useContext(SiteContext);
  /*
  |--------------------------------------------------------------------------
  | Select Date's source 
  |--------------------------------------------------------------------------
  |
  */
  const selectedDate =
    source === "faire"
      ? faireProductSync
      : source === "wix"
      ? wixProductSync
      : source === "order"
      ? faireOrderSync
      : "";
  return (
    <Box>
      <Text weight="normal" light secondary gap={"5px"} size="tiny">
        (Last Synced:
        <Text secondary size="tiny" weight="bold">
          {selectedDate ? " " + selectedDate : " Not Imported"}
        </Text>
        )
      </Text>
    </Box>
  );
};
export default SyncedDate;
